import { OnInit, Component, ViewEncapsulation, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ValidatorService } from 'app/shared/services/validator.service';
import { Subject } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AppConfig } from 'app/app.config';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { OrganizationService } from 'app/views/appviews/organization/organization.service';
import { ISelect } from 'app/shared/models/select.model';
import { IDtoEmployerRegister } from 'app/shared/models/organization/dto-employer-register.model';

@Component({
    selector: 'app-modal-employer-register',
    styleUrls: ['./modal-employer-register.style.scss'],
    templateUrl: './modal-employer-register.template.html',
    encapsulation: ViewEncapsulation.None
})

export class ModalEmployerRegisterComponet implements OnInit {
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private errorMessages: any;
    /**Formularios */
    private formEmployerRegister: FormGroup;
    /**Retorno a pantalla padre */
    public onClose: Subject<any>;
    /**Variables */
    private employerRegister: IDtoEmployerRegister;
    private customerId?: number;
    private action = 'add';
    /**Listas */
    private employerRegisters = new Array() as IDtoEmployerRegister[];
    /** Tablas*/
    @ViewChild(DatatableComponent, { static: false }) tableEmployerRegisters: DatatableComponent;
    /** Catalogos */
    private catalogZones: ISelect[];
    constructor(private bsModalRef: BsModalRef
        , private formBuilder: FormBuilder
        , private organizationService: OrganizationService
        , private configGeneral: AppConfig) {
        this.initializeFormRiskPremium();
    }
    ngOnInit(): void {
        this.organizationService.getCatalogZones().subscribe(res => {
            this.catalogZones = res;
            this.organizationService.getEmployerRegistersByCustomerId(this.customerId).subscribe(res => {
                this.employerRegisters = res.data as IDtoEmployerRegister[];
                this.employerRegisters.forEach(element => {
                    element.zone = this.catalogZones.filter(f => f.id == element.zoneId.toString())[0].text;
                });
            });
        });
        this.onClose = new Subject();
    }
    private initializeFormRiskPremium() {
        this.formEmployerRegister = this.formBuilder.group({
            imss: [null, [Validators.required, Validators.maxLength(11)]],
            guide: [null, [Validators.required, Validators.maxLength(5)]],
            location: [null, [Validators.required, Validators.maxLength(3)]],
            zoneId: [null, [Validators.required]]
        });
    }
    private submit(): void {
        if (this.formEmployerRegister.valid) {
            if (this.action === 'add') {
                this.save();
            } else {
                this.update();
            }
        } else {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.configGeneral.touchedControls(this.formEmployerRegister);
        }
    }
    private save(): void {
        const dto = this.formEmployerRegister.value as IDtoEmployerRegister;
        dto.customerId = this.customerId;
        this.organizationService.addEmployerRegister(dto)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        let e = x.data as IDtoEmployerRegister;
                        e.zone = this.catalogZones.filter(f => f.id == e.zoneId.toString())[0].text;
                        this.employerRegisters.push(e);
                        this.employerRegisters = [...this.employerRegisters];
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private update(): void {
        const dto = this.formEmployerRegister.value as IDtoEmployerRegister;
        dto.customerId = this.employerRegister.customerId;
        dto.id = this.employerRegister.id;
        this.organizationService.updateEmployerRegister(dto)
            .subscribe(
                (x) => {
                    if (this.configGeneral.notificationSuccessError(x)) {
                        let index = this.employerRegisters.indexOf(this.employerRegister)
                        if (index > -1) {
                            dto.zone = this.catalogZones.filter(f => f.id == dto.zoneId.toString())[0].text;
                            this.employerRegisters.splice(index, 1);
                            this.employerRegisters.push(dto);
                            this.employerRegisters = [...this.employerRegisters];
                        }
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private onCancel(): void {
        this.bsModalRef.hide();
    }
    private selectRow(item: IDtoEmployerRegister): void {
        this.employerRegister = item;
        this.employerRegister.zoneId = this.employerRegister.zoneId.toString();
        this.formEmployerRegister.patchValue(this.employerRegister);
        this.action = 'edit';
    }
    private resetForm(): void {
        this.formEmployerRegister.reset();
        this.action = 'add';
    }
}
